import { gql } from '@apollo/client'

export const AI_RECOMMENDATION_PROMPT = gql`
  query AiRecommendationPrompt {
    aiRecommendationPrompt {
      id
      content
      updatedAt
    }
  }
`
